
import { Component, Watch, Vue } from 'vue-property-decorator'
import dashboardModule from '@/store/dashboard'

@Component({
  name: 'MessageAlert'
})
class MessageAlert extends Vue {
  private showAlert = false

  private get alertMessage() {
    return dashboardModule.message
  }

  private get alertType() {
    return dashboardModule.color
  }

  private get alertWidth() {
    return this.$vuetify.breakpoint.mdAndUp ? '50vw' : '90vw'
  }

  @Watch('alertMessage')
  private updateAlert(val: string) {
    if (val && val.trim().length > 0) {
      this.showAlert = true
    }
  }

  @Watch('showAlert')
  private alertCountdown() {
    setTimeout(() => {
      this.showAlert = false
      dashboardModule.resetMessage()
    }, 3000)
  }
}

export default MessageAlert
